import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import generatePicker from 'antd/es/date-picker/generatePicker';
import { useStore } from 'zustand';

import { dateGenerateConfig } from 'app/components/fields/dateGenerateConfig';
import { addDays, getWeek } from 'app/utils/dayjs';
import { amplitudeTrack } from 'app/utils/track/amplitude';

import { inventoryStore } from '../../../InventoryStore';
import { NUMBER_OF_DAYS_RANGE } from '../../../utils';

const DatePicker = generatePicker<Date>(dateGenerateConfig);

type DateRangeControlProps = {
  startTransition: React.TransitionStartFunction;
};

export const DateRangeControl = ({
  startTransition,
}: DateRangeControlProps) => {
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);
  const timePeriod = useStore(inventoryStore, (state) => state.timePeriod);
  const setTimePeriod = useStore(
    inventoryStore,
    (state) => state.setTimePeriod
  );
  const formHasChanged = useStore(
    inventoryStore,
    (state) => state.formHasChanged
  );
  const setSaveChangesModal = useStore(
    inventoryStore,
    (state) => state.setSaveChangesModal
  );

  const shiftPeriod = async (days: number) => {
    startTransition(() => {
      const startDate = addDays(timePeriod.startDate, days);

      if (days > 0) {
        amplitudeTrack('Click next sales arrow', {
          week_number: getWeek(startDate),
        });
      }

      if (formHasChanged && isEditMode) {
        setSaveChangesModal({
          isVisible: true,
          timePeriod: {
            startDate,
            endDate: addDays(timePeriod.endDate, days),
          },
        });

        return;
      }

      setTimePeriod({
        startDate,
        endDate: addDays(timePeriod.endDate, days),
      });
    });
  };

  return (
    <div className="date-range-action">
      <Button onClick={() => shiftPeriod(-NUMBER_OF_DAYS_RANGE)}>
        <LeftOutlined />
      </Button>
      <DatePicker.RangePicker
        value={[timePeriod.startDate, timePeriod.endDate]}
        disabled
        format="ddd DD/MM"
        className="date-range-action-modifier-display"
      />
      <Button onClick={() => shiftPeriod(NUMBER_OF_DAYS_RANGE)}>
        <RightOutlined />
      </Button>
    </div>
  );
};
